import { render, staticRenderFns } from "./EstabelecimentosEquipesServicosIcon.vue?vue&type=template&id=9206eeee"
import script from "./EstabelecimentosEquipesServicosIcon.vue?vue&type=script&lang=js"
export * from "./EstabelecimentosEquipesServicosIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports